/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

jQuery(document).ready(function($) {

  //Statistics section script
  $('#chart_selector').on('change', function(){
    let chart_parameter = $(this).val();
    $('.chart-wrapper').removeClass('active');
    $(`.chart-wrapper[data-parameter="${chart_parameter}"]`).addClass('active');
  });

    // Custom Statistics section script
  $('.custom-statistics select').on('change', function(){
    let chart_parameter = $(this).val();
    $('.chart-wrapper').removeClass('active');
    $(`.chart-wrapper[data-parameter="${chart_parameter}"]`).addClass('active');
  });
  
  // Header cart button Click Event
  $("#header-cart").click(function(e) {
    e.preventDefault();
    var baseUrl = "https://42605a.myshopify.com/cart/";
    jQuery.getJSON('/cart.js', function(cart) {
      // Get the most recently added item in the cart
      var lastAddedItem = cart.items[cart.items.length - 1];
      // Get the variant ID of the most recently added item
      var variantId = lastAddedItem.variant_id;
      // Use the variant ID as needed
      location.href = `${baseUrl}${variantId}:1`;
    });
  });

  // Sales pop container click event
$(document).off("click", "#sales-pop-container a").on('click', '#sales-pop-container a', function(e) {
    e.preventDefault();
    var baseUrl = "https://42605a.myshopify.com/cart/";
    jQuery.getJSON('/cart.js', function(cart) {
        // Get the most recently added item in the cart
        var lastAddedItem = cart.items[cart.items.length - 1];
        // Get the variant ID of the most recently added item
        var variantId = lastAddedItem.variant_id;
        // Use the variant ID as needed
        location.href = `${baseUrl}${variantId}:1`;
    });
});

  
  // Aspects product sumbmission script
  $(document).on('click', '.aspects-submit-variant-item:not(.active)', function(){
    $('.aspects-submit-variant-item').removeClass('active');
    $(this).addClass('active');
  })
  $("#aspects_submit").on('click', function(){
    let variantId = $('.aspects-submit-variant-item.active').data('variant');
    var baseUrl = "https://42605a.myshopify.com/cart/";
    location.href=`${baseUrl}${variantId}:1`;
    // $.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: {
    //       id: variantId,
    //       quantity: 1,
    //     },
    //     dataType: 'json',
    //     beforeSend: function() {
    //       $('#aspects_submit .loader-button__text').addClass('hidden');
    //       $('#aspects_submit .loader-button').removeClass('hidden');
    //     },
    //     success: function() {
    //       // Trigger cart update          
    //       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    //         bubbles: true
    //       }));          
    //     },
    //     complete: function () {
    //       $('#aspects_submit .loader-button__text').removeClass('hidden');
    //       $('#aspects_submit .loader-button').addClass('hidden');
    //       document.getElementById('mini-cart').open = true;
    //     },
    //     error: function(XMLHttpRequest) {
    //       alert(XMLHttpRequest.responseJSON.description);
    //         // Handle error.
    //     }
    // });
  });

  $(".zpa-add-to-cart-btn").on('click', function(){
    let variantId = $('.zpa-product-option__input:checked+.zpa-product-option__item--text>div').data('variant');
    var baseUrl = "https://42605a.myshopify.com/cart/";
    location.href=`${baseUrl}${variantId}:1`;
  });  

  // Check if the device is not a mobile device
  // if (!('ontouchstart' in window) && $(window).width() > 768) {
  //     $(".custom_accordion .custom_package").on('dblclick', function(){
  //         let variantId = $('.zpa-product-option__input:checked+.zpa-product-option__item--text>div').data('variant');
  //         var baseUrl = "https://42605a.myshopify.com/cart/";
  //         location.href=`${baseUrl}${variantId}:1`;
  //     });
  // }
  
  // Ingredients mobile slider 
  if($(window).width()<768) {
    $('.shopify-section--ingredients .multi-column__inner').slick({
      // autoplay: true,
      // autoplaySpeed: 3000,
      dots: true,
      infinite: false,      
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: `<button type="button" class="slick-prev prev-next-button prev-next-button--prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M10.733 19.79C10.878 19.9213 11.0686 19.9907 11.2641 19.9834C11.4596 19.9761 11.6445 19.8927 11.7794 19.7511C11.9143 19.6094 11.9885 19.4206 11.9862 19.225C11.9838 19.0294 11.9052 18.8425 11.767 18.704L5.51599 12.75H20.25C20.4489 12.75 20.6397 12.671 20.7803 12.5303C20.921 12.3897 21 12.1989 21 12C21 11.8011 20.921 11.6103 20.7803 11.4697C20.6397 11.329 20.4489 11.25 20.25 11.25H5.51599L11.767 5.29502C11.9052 5.15658 11.9838 4.96962 11.9862 4.77402C11.9885 4.57841 11.9143 4.38964 11.7794 4.24797C11.6445 4.1063 11.4596 4.02293 11.2641 4.01566C11.0686 4.00838 10.878 4.07777 10.733 4.20902L3.31299 11.276C3.15059 11.4301 3.0449 11.6344 3.01299 11.856C2.99469 11.9515 2.99503 12.0497 3.01399 12.145C3.04611 12.3662 3.15179 12.5702 3.31399 12.724L10.733 19.79Z" fill="#B38E4A"/>
          </svg>
        </button>`,
      nextArrow: `<button type="button" class="slick-next prev-next-button prev-next-button--next">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M13.267 4.20902C13.122 4.07777 12.9314 4.00838 12.7359 4.01566C12.5404 4.02293 12.3555 4.1063 12.2206 4.24797C12.0857 4.38964 12.0115 4.57841 12.0138 4.77402C12.0161 4.96962 12.0948 5.15658 12.233 5.29502L18.484 11.25H3.75C3.55109 11.25 3.36032 11.329 3.21967 11.4697C3.07902 11.6103 3 11.8011 3 12C3 12.1989 3.07902 12.3897 3.21967 12.5303C3.36032 12.671 3.55109 12.75 3.75 12.75H18.484L12.233 18.704C12.0889 18.8411 12.0051 19.0299 12.0001 19.2288C11.9951 19.4277 12.0694 19.6204 12.2065 19.7645C12.3436 19.9087 12.5324 19.9924 12.7313 19.9974C12.9301 20.0024 13.1229 19.9281 13.267 19.791L20.687 12.724C20.8493 12.5699 20.955 12.3656 20.987 12.144C21.0053 12.0482 21.005 11.9497 20.986 11.854C20.9537 11.6332 20.848 11.4296 20.686 11.276L13.267 4.20902Z" fill="#B38E4A"/>
          </svg>
        </button>`      
    });
  }

  // Videos slider
  if($('.shopify-section--multi-video').length) {
    $('.shopify-section--multi-video .videos-wrapper').slick({
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      speed: 500,
      swipeToSlide: true,
      infinite: true,
      centerMode: true,
      variableWidth: true,
      prevArrow: `<button type="button" class="slick-prev prev-next-button prev-next-button--prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M10.733 19.79C10.878 19.9213 11.0686 19.9907 11.2641 19.9834C11.4596 19.9761 11.6445 19.8927 11.7794 19.7511C11.9143 19.6094 11.9885 19.4206 11.9862 19.225C11.9838 19.0294 11.9052 18.8425 11.767 18.704L5.51599 12.75H20.25C20.4489 12.75 20.6397 12.671 20.7803 12.5303C20.921 12.3897 21 12.1989 21 12C21 11.8011 20.921 11.6103 20.7803 11.4697C20.6397 11.329 20.4489 11.25 20.25 11.25H5.51599L11.767 5.29502C11.9052 5.15658 11.9838 4.96962 11.9862 4.77402C11.9885 4.57841 11.9143 4.38964 11.7794 4.24797C11.6445 4.1063 11.4596 4.02293 11.2641 4.01566C11.0686 4.00838 10.878 4.07777 10.733 4.20902L3.31299 11.276C3.15059 11.4301 3.0449 11.6344 3.01299 11.856C2.99469 11.9515 2.99503 12.0497 3.01399 12.145C3.04611 12.3662 3.15179 12.5702 3.31399 12.724L10.733 19.79Z" fill="#B38E4A"/>
          </svg>
        </button>`,
      nextArrow: `<button type="button" class="slick-next prev-next-button prev-next-button--next">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M13.267 4.20902C13.122 4.07777 12.9314 4.00838 12.7359 4.01566C12.5404 4.02293 12.3555 4.1063 12.2206 4.24797C12.0857 4.38964 12.0115 4.57841 12.0138 4.77402C12.0161 4.96962 12.0948 5.15658 12.233 5.29502L18.484 11.25H3.75C3.55109 11.25 3.36032 11.329 3.21967 11.4697C3.07902 11.6103 3 11.8011 3 12C3 12.1989 3.07902 12.3897 3.21967 12.5303C3.36032 12.671 3.55109 12.75 3.75 12.75H18.484L12.233 18.704C12.0889 18.8411 12.0051 19.0299 12.0001 19.2288C11.9951 19.4277 12.0694 19.6204 12.2065 19.7645C12.3436 19.9087 12.5324 19.9924 12.7313 19.9974C12.9301 20.0024 13.1229 19.9281 13.267 19.791L20.687 12.724C20.8493 12.5699 20.955 12.3656 20.987 12.144C21.0053 12.0482 21.005 11.9497 20.986 11.854C20.9537 11.6332 20.848 11.4296 20.686 11.276L13.267 4.20902Z" fill="#B38E4A"/>
          </svg>
        </button>`
    });
  }

  // Testimonials Carousel
  if($('.shopify-section--testimonials-carousel').length) {
    $('.shopify-section--testimonials-carousel .multi-column__inner').slick({
      // autoplay: true,
      // autoplaySpeed: 3000,
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: `<button type="button" class="slick-prev prev-next-button prev-next-button--prev">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M10.733 19.79C10.878 19.9213 11.0686 19.9907 11.2641 19.9834C11.4596 19.9761 11.6445 19.8927 11.7794 19.7511C11.9143 19.6094 11.9885 19.4206 11.9862 19.225C11.9838 19.0294 11.9052 18.8425 11.767 18.704L5.51599 12.75H20.25C20.4489 12.75 20.6397 12.671 20.7803 12.5303C20.921 12.3897 21 12.1989 21 12C21 11.8011 20.921 11.6103 20.7803 11.4697C20.6397 11.329 20.4489 11.25 20.25 11.25H5.51599L11.767 5.29502C11.9052 5.15658 11.9838 4.96962 11.9862 4.77402C11.9885 4.57841 11.9143 4.38964 11.7794 4.24797C11.6445 4.1063 11.4596 4.02293 11.2641 4.01566C11.0686 4.00838 10.878 4.07777 10.733 4.20902L3.31299 11.276C3.15059 11.4301 3.0449 11.6344 3.01299 11.856C2.99469 11.9515 2.99503 12.0497 3.01399 12.145C3.04611 12.3662 3.15179 12.5702 3.31399 12.724L10.733 19.79Z" fill="#B38E4A"/>
              </svg>
            </button>`,
          nextArrow: `<button type="button" class="slick-next prev-next-button prev-next-button--next">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M13.267 4.20902C13.122 4.07777 12.9314 4.00838 12.7359 4.01566C12.5404 4.02293 12.3555 4.1063 12.2206 4.24797C12.0857 4.38964 12.0115 4.57841 12.0138 4.77402C12.0161 4.96962 12.0948 5.15658 12.233 5.29502L18.484 11.25H3.75C3.55109 11.25 3.36032 11.329 3.21967 11.4697C3.07902 11.6103 3 11.8011 3 12C3 12.1989 3.07902 12.3897 3.21967 12.5303C3.36032 12.671 3.55109 12.75 3.75 12.75H18.484L12.233 18.704C12.0889 18.8411 12.0051 19.0299 12.0001 19.2288C11.9951 19.4277 12.0694 19.6204 12.2065 19.7645C12.3436 19.9087 12.5324 19.9924 12.7313 19.9974C12.9301 20.0024 13.1229 19.9281 13.267 19.791L20.687 12.724C20.8493 12.5699 20.955 12.3656 20.987 12.144C21.0053 12.0482 21.005 11.9497 20.986 11.854C20.9537 11.6332 20.848 11.4296 20.686 11.276L13.267 4.20902Z" fill="#B38E4A"/>
              </svg>
            </button>`,
      responsive: [
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }  
  
});